// AUTO-GENERATED by scripts/gen-gateway-demos.mjs — real example outputs for
// every gateway playground model, hosted on appstatic.app.nz. Images webp q85,
// audio opus, video vp9 webm. Keyed "<playground-tab>|<model-id>" using the ids
// published by /api/gateway/models.
export type GatewayDemo = {
  prompt?: string;
  mediaUrl?: string;
  mediaKind?: 'image' | 'video' | 'audio' | 'model';
  posterUrl?: string;
  inputUrl?: string;
  voice?: string;
  size?: string;
  resolution?: string;
  duration?: string;
  aspectRatio?: string;
  generateAudio?: boolean;
  reply?: string;
  transcript?: string;
  embedDims?: number;
  embedPreview?: number[];
  embedUrl?: string;
  note?: string;
};

export const GATEWAY_DEMOS: Record<string, GatewayDemo> = {
  "embeddings|codestral-embed": {
    "prompt": "app.nz routes every model through one API",
    "embedDims": 1536,
    "embedPreview": [
      -0.0748,
      0.0551,
      -0.1747,
      0.0578,
      0.1582,
      -0.0437,
      0.1327,
      -0.0149
    ],
    "embedUrl": "https://appstatic.app.nz/app/static/demos/embeddings/codestral-embed.json"
  },
  "embeddings|mistral-embed": {
    "prompt": "app.nz routes every model through one API",
    "embedDims": 1024,
    "embedPreview": [
      0.0038,
      0.0508,
      0.0599,
      -0.014,
      0.0325,
      0.0035,
      0.0064,
      -0.0072
    ],
    "embedUrl": "https://appstatic.app.nz/app/static/demos/embeddings/mistral-embed.json"
  },
  "embeddings|openpaths-embed": {
    "prompt": "app.nz routes every model through one API",
    "embedDims": 512,
    "embedPreview": [
      0.5638,
      13.5041,
      -0.1569,
      -0.9053,
      -9.5185,
      0.8521,
      -0.0927,
      -1.0835
    ],
    "embedUrl": "https://appstatic.app.nz/app/static/demos/embeddings/openpaths-embed.json"
  },
  "embeddings|text-embedding": {
    "prompt": "app.nz routes every model through one API",
    "embedDims": 768,
    "embedPreview": [
      -0.3608,
      1.4288,
      -1.1386,
      2.3219,
      -2.4715,
      0.3931,
      1.1654,
      -0.0045
    ],
    "embedUrl": "https://appstatic.app.nz/app/static/demos/embeddings/text-embedding.json"
  },
  "image|cutedsl-image": {
    "prompt": "Frost crystals blooming across a teal leaf, extreme macro photography, ultra-sharp detail",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/cutedsl-image.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|fal-ai/fast-lightning-sdxl/image-to-image": {
    "prompt": "Loose watercolor restyle with soft bleeding edges",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/fal-ai-fast-lightning-sdxl-image-to-image.webp",
    "mediaKind": "image",
    "inputUrl": "https://netwrckstatic.netwrck.com/static/uploads/test/appnz-probe-fox.webp",
    "size": "1024x1024"
  },
  "image|fal-ai/flux/dev/image-to-image": {
    "prompt": "Painterly oil-portrait interpretation with rich impasto brushwork",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/fal-ai-flux-dev-image-to-image.webp",
    "mediaKind": "image",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/fal-video/rap.png",
    "size": "1024x1024"
  },
  "image|fast-sdxl": {
    "prompt": "Cozy reading nook in a sunlit bookshop, dust motes drifting through warm light, photorealistic interior",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/fast-sdxl.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|flux-dev": {
    "prompt": "Brutalist library carved into a sea cliff at dusk, warm windows glowing against teal water, cinematic wide shot",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/flux-dev.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|flux-img2img": {
    "prompt": "Cinematic neon rim-light portrait, moody blue grade, rain-specked window bokeh",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/flux-img2img.webp",
    "mediaKind": "image",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/fal-video/rap.png",
    "size": "1024x1024"
  },
  "image|glm-image": {
    "prompt": "Silk-scroll painting of a maglev train crossing misty karst mountains, delicate ink wash",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/glm-image.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|gpt-image-1": {
    "prompt": "Cross-section illustration of a lighthouse powered by a giant firefly lantern",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/gpt-image-1.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|gpt-image-1-mini": {
    "prompt": "Die-cut sticker of a smiling capybara barista holding a latte, white border",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/gpt-image-1-mini.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|gpt-image-1.5": {
    "prompt": "Vintage travel poster of a ringed planet with a funicular descending to its moons",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/gpt-image-1.5.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|gpt-image-2": {
    "prompt": "A steam-powered owl delivering letters over Victorian rooftops at sunrise, storybook illustration",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/gpt-image-2.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|klein": {
    "prompt": "Origami fox standing on rolled blueprints, papercraft diorama, shallow depth of field, studio lighting",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/klein.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|lightning-img2img": {
    "prompt": "Golden-hour relight with warm rim light and soft haze",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/lightning-img2img.webp",
    "mediaKind": "image",
    "inputUrl": "https://netwrckstatic.netwrck.com/static/uploads/test/appnz-probe-fox.webp",
    "size": "1024x1024"
  },
  "image|openpaths/auto-image": {
    "prompt": "A beige coffee mug on a wooden table, soft natural light",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/openpaths-auto-image.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|openpaths/image-edit": {
    "prompt": "Add round wire-rimmed spectacles",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/openpaths-image-edit.webp",
    "mediaKind": "image",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/fal-video/rap.png",
    "size": "1024x1024"
  },
  "image|ra1": {
    "prompt": "A crystalline koi dragon arcing through sunset clouds, iridescent scales refracting golden light, epic fantasy illustration",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/ra1.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "image|seamless-tiling": {
    "prompt": "Seamless tileable dark walnut wood grain texture, even studio light",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/seamless-tiling.webp",
    "mediaKind": "image",
    "inputUrl": "https://netwrckstatic.netwrck.com/static/uploads/test/appnz-probe-fox.webp",
    "size": "1024x1024"
  },
  "image|zimage": {
    "prompt": "Lantern-lit train platform floating above a koi pond at blue hour, anime key visual, paper lantern reflections on still water",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/image/zimage.webp",
    "mediaKind": "image",
    "size": "1024x1024"
  },
  "speech|appnz-tts": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/appnz-tts.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|gemini-3.1-flash-tts-preview": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/gemini-3.1-flash-tts-preview.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|grok-voice-latest": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/grok-voice-latest.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|grok-voice-think-fast-1.0": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/grok-voice-think-fast-1.0.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|grok-voice-think-fast-2.0": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/grok-voice-think-fast-2.0.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|pocket-tts": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/pocket-tts.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|speech-2.6-hd": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/speech-2.6-hd.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|speech-2.6-turbo": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/speech-2.6-turbo.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|speech-2.8-hd": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/speech-2.8-hd.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|speech-2.8-turbo": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/speech-2.8-turbo.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "speech|xai-tts": {
    "prompt": "Welcome to app.nz. One API key routes every model to its best provider.",
    "mediaUrl": "https://appstatic.app.nz/app/static/demos/speech/xai-tts.opus",
    "mediaKind": "audio",
    "voice": "eve"
  },
  "video|alibaba/happy-horse/image-to-video": {
    "prompt": "Bring the scene in the image to life with natural motion and ambient audio.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/fal-video/happy-horse-v1.1-image-to-video.mp4",
    "mediaKind": "video",
    "posterUrl": "https://appstatic.app.nz/app/static/uploads/playground/fal-video/rap.png",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/fal-video/rap.png",
    "resolution": "1080p",
    "duration": "5",
    "aspectRatio": "16:9",
    "generateAudio": true
  },
  "video|fal-ai/kling-video/v3/pro/text-to-video": {
    "prompt": "A lone astronaut drifts weightless inside a derelict space station, dust motes glittering in shafts of golden sunlight through cracked viewports, slow cinematic dolly push, volumetric god rays.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/fal-video/kling-v3-pro-text-to-video.mp4",
    "mediaKind": "video",
    "resolution": "1080p",
    "duration": "5",
    "aspectRatio": "16:9",
    "generateAudio": true
  },
  "video|gemini-omni-flash-preview": {
    "prompt": "[# Sources <FIRST_FRAME>@Image1] Continuous single-shot premium product video: the perfume bottle remains the hero object from the input image, the camera makes a slow cinematic push-in, soft studio lights sweep across the glass, subtle reflections move on the surface, no scene cuts, no added text, no dialogue. Use Image1 as the starting frame.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/gemini-omni/gemini-omni-perfume-image-to-video.mp4",
    "mediaKind": "video",
    "posterUrl": "https://appstatic.app.nz/app/static/uploads/playground/gemini-omni/perfume.jpg",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/gemini-omni/perfume.jpg",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "16:9",
    "generateAudio": false
  },
  "video|seedance-2.0-fast-reference-to-video": {
    "prompt": "Use @Image1 as the exact brand mark on a small illuminated badge mounted to a matte black server rack. Slow dolly-in, shallow depth of field, cool white rim light, subtle cable movement, premium infrastructure commercial, no extra text.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/seedance/seedance-2.0-fast-reference-to-video.mp4",
    "mediaKind": "video",
    "posterUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "16:9",
    "generateAudio": false
  },
  "video|seedance-2.0-fast-text-to-video": {
    "prompt": "A cinematic 4-second shot of a sleek AI gateway console on a dark workstation, luminous routes connecting model nodes across glass, slow handheld push-in, realistic reflections, premium product demo lighting, no readable text.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/seedance/seedance-2.0-fast-text-to-video.mp4",
    "mediaKind": "video",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "16:9",
    "generateAudio": false
  },
  "video|seedance-2.0-image-to-video": {
    "prompt": "Animate the supplied app.nz logo as a premium product mark: subtle camera push-in, soft light sweep across the surface, tiny particles drifting around it, clean dark studio background, elegant motion, no added text.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/seedance/seedance-2.0-image-to-video.mp4",
    "mediaKind": "video",
    "posterUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "1:1",
    "generateAudio": false
  },
  "video|seedance-2.0-reference-to-video": {
    "prompt": "@Image1 is projected as a crisp holographic interface element above a developer desk. Camera slides left to right, soft reflections on glass, realistic workstation lighting, cinematic product demo, no additional words or watermarks.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/seedance/seedance-2.0-reference-to-video.mp4",
    "mediaKind": "video",
    "posterUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "inputUrl": "https://appstatic.app.nz/app/static/uploads/playground/seedance/applogo.png",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "16:9",
    "generateAudio": false
  },
  "video|seedance-2.0-text-to-video": {
    "prompt": "A polished studio macro shot of an AI platform dashboard rendered as glowing fiber-optic routes inside a transparent cube, slow orbiting camera, cinematic depth of field, clean black background, no readable text.",
    "mediaUrl": "https://appstatic.app.nz/app/static/videos/seedance/seedance-2.0-text-to-video.mp4",
    "mediaKind": "video",
    "resolution": "720p",
    "duration": "4",
    "aspectRatio": "16:9",
    "generateAudio": false
  }
};
